<template>
    <b-modal
        id="customer-contact-modal"
        ref="customer-contact-modal"
        title="Add Customer Contact Form"
        size="lg"
        centered
        scrollable
        hide-footer
    >
        <permission-alert-gate :permissions="'add customer contact'">
        <template #gated-content>
            <customer-contact-form @submit="submit" />
        </template>
        </permission-alert-gate>
    </b-modal>
</template>

<script>
import CustomerContactForm from "@/components/crm/customercontact/form/CustomerContactForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";

export default {
    name: "CustomerContactModal",
    components: {
        CustomerContactForm,
        PermissionAlertGate,
    },
    methods: {
        submit(form_data) {
            this.$emit('formSubmitted', form_data);
        }
    }
}
</script>